<template>
    <split-pane  :min-percent='10' :default-percent='15' split="vertical">
        <template slot="paneL">
            <el-input placeholder="请输入关键字进行过滤" v-model="filterText" size="medium"  ></el-input> 
            <el-tree :data="accData" 
                        :props="defaultProps" 
                        @node-click="handleNodeClick" 
                        node-key="id"                       
                        :style="{height: scrollerHeight,overflow:'auto',display: 'flex',padding:15}"
                        highlight-current
                        :filter-node-method="filterNode"
                        v-loading="loadingtree"
                        element-loading-text="加载中"
                        element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(255, 251, 255, 0.8)"   
                        ref="eltree"
                        default-expand-all
                        :expand-on-click-node="false">
                <template v-slot="{node,data}">                                     
                    <span v-if="data.id ==0 "  class="nodeRoot" >
                     <i class="iconfont   icon-kucunguanli" style="color:#409eff;font-size:16px;margin-right:3px;"></i>
                     <span class="nodeLabel" style="font-size:14px;font-weight:600;color:#409efe">{{ node.label}} </span>
                    </span>                  
                    <span v-else > 
                        <i class="iconfont icon-fenzhijiedian" style="color:#409eff;font-size:14px;margin-right:3px;"></i><span class="nodeLabel">{{ node.label}} </span>
                    </span>
                </template>
            </el-tree>
        </template>  
        <template slot="paneR">         
            <div class="headbar">
 
                <el-button type="text" size="mini" icon="iconfont icon-chenggong1" @click="selSure" style="margin-left:5px;height:35px;margin-top:3px;">确定选择</el-button>
                <el-select v-model="selparam"  placeholder="请选择列名" clearable size="small" style="width:150px;line-height:35px;">
                    <span v-for="item in tabArr" :key='item.key'>
                        <el-option :label="item.title" :value="item.key" style="width:150px;"></el-option>
                    </span>
                </el-select>
                <el-input placeholder="请输入查询值" v-model="txtparam" size="small" style="width:380px;margin-left:2px;margin-top:3px; ">
                    <el-button size="small" slot="append" icon="el-icon-search" @click="qryTabData" style="color:#409eff"></el-button>
                    <div slot="prepend">
                        <el-select v-model="oper"  size="small" style="width:110px;" >
                            <el-option label="等于" value="="  ></el-option>
                            <el-option label="相似于" value="like"  ></el-option>
                            <el-option label="大于等于" value="&ge;"  ></el-option>
                            <el-option label="小于等于" value="&le;" ></el-option>
                        </el-select>
                    </div>
                </el-input>  
            </div>
            <el-table  :data="tabData" 
                    border                            
                    disabled-hover
                    style="overflow:auto;margin-top:1px;"
                    size="small"
                    :height="tabHeight" 
                    :row-key="getRowKey"  
                    ref="tabref" 
                    @row-click="rowClick"
                    @row-dblclick="selSure"
                    highlight-current-row>
                <span v-for="(item,index ) in tabArr" :key="index">
                    <el-table-column  v-if="item.thide==='N' && item.edcss!=='checkbox'"
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"                                  
                        sortable
                        :min-width="item.width">
                    </el-table-column> 
                    <el-table-column  v-if="item.thide==='N' && item.edcss==='checkbox'"
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"                                  
                        sortable
                        :min-width="item.width">
                        <template   slot-scope="scope" >
                            <el-checkbox  disabled true-label="Y"  false-label="N" v-model="scope.row.STFG" ></el-checkbox>
                        </template>
                    </el-table-column> 
                </span>
                    
            </el-table> 
            <div style="margin-top: 3px; overflow: hidden;display:flex;background:white">
                <div style="float: left;">
                    <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
                </div>
                <div style="color:#606266;margin:7px 10px;font-size:12px;width:35px;">每页</div>
                <el-select v-model="rowSize" size="small" style="width:80px;"  @change="initPage">
                    <el-option 
                        v-for="item in pageList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
                <div style="color:#606266;margin:7px 10px;margin-left:80px;font-size:12px;width:30px;">跳至</div>
                <el-input v-enter-number size="small" v-model="goPage" style="width:50px;"></el-input> 
                <span style="color:#606266;margin:7px 5px;font-size:12px;">页</span>
                <el-button @click="goNext" size="small" type="primary" style="width:50px;margin-left:15px;height:32px;">GO</el-button>
            </div> 
 
            <el-dialog :visible.sync="promptWin" width="450px" append-to-body :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
                </div> 
                <span>{{prompt}}</span>
                <span slot="footer"  >
                    <el-button size="small" type="primary" @click="promptWin = false">确 定</el-button>
                </span>
            </el-dialog>
 
        </template>     
    </split-pane> 
</template>

<script>
  
  import { getTabColOrData,getBaseData } from '../../api/user'
  export default {
    components: {
       
    },
    data() {
      return {
        promptWin:false,
        prompt:'',
 
        formCol:{}, //表格单行记录 model
        accData:[] , //树结构数据
        oper:'like',
        selparam:'',
        txtparam:'',
        loadingtree:false,
        filterText: '',
        defaultProps: {  //el-tree 默认字段属性
            children: 'children',
            id:'id',
            icon:'icon',
            parentid:'',
            label: 'label'
        },
        ruleValidate:{}, //校验规则
        addFlag: 'create',
        nodeLabel:this.$cookies.get('v_corpnm'),
        treeid :'0',
        parentid:'',
        allData:[],
        tabData:[],
        tabArr:[],
        saveFlag:false,
        v_url:'xuper_auth/getTableRecMany' , //api请求路径
        addBool:false, //新增,为true时--禁止
        editBool:false, //编辑,为true时--禁止
        delBool:false, //删除 ,为true时--禁止
        cfmBool:false, //审核 ,为true时--禁止
        cancelBool:false, //作废 ,为true时--禁止 
        v_admin:this.$cookies.get('v_admin') ,//      
        v_username:this.$cookies.get('v_telno'), //api 请求用户
        
        v_corpid:this.$cookies.get('v_corpid') , //员工公司ID
        dataCount:0,
        rowSize:20,
        goPage:'',
        current:1,
        pageList: [ {
            value: 20,
            label: '20'
            }, {
            value: 30,
            label: '30'
            }, {
            value: 40,
            label: '40'
        }],
      }
    },
    watch: {
        filterText(val) {
            this.$refs.eltree.filter(val);
        }
    },
    created () {
        if(this.v_username){
            this.getData() //左边树
            this.getTabField() // 字段集
            this.getAccList(' and parentno=\''+this.treeid+'\'')  
        }else{
            let routeUrl = this.$router.resolve({
                path: '/login',
                query: {},
            });
            window.open(routeUrl.href, '_self');
        }
    },
    mounted () {
 
    },
    computed:{
            scrollerHeight: function() {
                return (window.innerHeight - 148) + 'px';
            },
            tabHeight: function() {
                return (window.innerHeight - 190) + 'px';
            }, 
        },
    methods: {
        
        selSure(){
            if (this.formCol['CNAME']){
                this.$emit('child-sure',this.formCol['IDSEQ'],this.formCol['CNAME'])
            }else{
                this.promtWin=true
                this.prompt='请选择一行记录'
            }
        },
        //查询
        qryTabData(){
            let cond_=''
            if (this.selparam){ //列1
                if (this.oper==='like'){
                    cond_=cond_+' and '+this.selparam+' like \'%' + this.txtparam+'%\''
                }else{
                    cond_=cond_+' and '+this.selparam +this.oper+'\''+this.txtparam+'\''
                }
            }
            this.getAccList(' and parentno=\''+this.treeid+'\' '+cond_)
        },
        getRowKey(row){
            return row.IDSEQ
        },
        rowClick(row){
            this.formCol=row
        },
 
        //跳至页面
        goNext(){
            if (this.goPage){
                this.changePage(this.goPage)
                this.current =Number(this.goPage)
            }else{
                this.promtWin=true
                this.prompt='请输入跳至页数'
            }
        },
        //客户明细
        getAccList(cond){
            //获取所有产品记录且初始化分页记录         
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'', p_value:'',p_key2:'corpid', p_value2:this.v_corpid,p_cond:cond,p_table:'V_AC_iotype'},
            }).then(res=>{ 
                if (res.code==='200'){
                    this.allData =res.result
                    this.initPage() 
                }else{
                    this.promptWin=true
                    this.prompt=res.result
                }
                this.$nextTick(() => { //有固定列时 查询后重新布局
                    this.$refs.tabref.doLayout();
                })
            }) 
        },
        //初始化查询页条数
        initPage(){
            //产品明细
            this.dataCount =this.allData.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allData.length < this.rowSize){
                this.tabData = this.allData          
            }else{
                this.tabData =this.allData.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
            }
        },
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize;
            this.tabData = this.allData.slice(_start,_end);
        },
 
 
 
        //节点过滤
        filterNode(value, data) {
            if (!value) return true;
            return data.label.indexOf(value) !== -1;
        },
        //节点点击
        handleNodeClick(data){
            this.nodeLabel=data.label;            
            this.treeid =data.id
            this.parentid=data.parentid
            this.getAccList(' and parentno=\''+data.id+'\'')
        },
 
        //删除记录
        delRec(row){
            this.$confirm('你确定要删除此行记录吗','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                //发起删除请求
                var vm=this;
                //选判断有没子节点
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/getBaseData',
                    data: {p_key:'parentno',p_value:row.IDNO,p_key2:'corpid',p_value2:this.v_corpid,p_table:'v_AC_IOTYPE'},
                }).then(res=>{  
                    if (res.result.length===0){
                        this.$axios({
                            method: 'post',
                            url:'xuper_auth/delTabRec',
                            data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'ac_IOTYPE'},
                        }).then(res=>{      
                            if(res.code =='200')  {           
                                vm.getData()   
                                vm.getAccList(' and parentno=\''+this.treeid+'\'')     
                            }else{
                                this.promptWin=true
                                this.prompt=res.result
                            }        
                        }) 
                    }else{
                        this.promptWin=true
                        this.prompt='存在子记录,不能删除'
                    }
                })      
            }).catch(()=>{})
        },
        // 获取 树形控件数据
        getData() {   
            var vm=this;
            this.loadingtree=true
            this.$axios({
                method: 'post',
                url:'xuper_auth/getElTreeData',
                data: {p_table:'V_IOTYPE_MENU',p_cond:' and ( corpid=\''+this.v_corpid+'\')'}
            }).then(function(res){ 
                if (res.code==='200'){                 
                    vm.accData =res.result;  
                    vm.$nextTick(()=>{ //必须要放在nexttick里，要不然还未渲染上
                        vm.$refs.eltree.setCurrentKey(vm.treeid)
                    })
                } else{
                    vm.promptWin=true
                    vm.prompt=res.result
                }  
                vm.loadingtree=false          
            })                            
        },
        //获取表列字段
        getTabField(){
            let vm =this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','15900','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.tabArr.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss: res.result[k].EDCSS,
                        thide:res.result[k].THIDE,
                        holder:res.result[k].HOLDER,
                        fhide:res.result[k].FHIDE,
                        disabled:res.result[k].DISABLED,
                    })
                }
            })
        }
    }
  }
</script>
<style scoped>
 .siderCls{
     background:#fff;
     margin: 3px auto;
     width: 260px;
     min-width: 260px;
     max-width:260px;
     border-right: 2px solid #C0C4CC;
}
    .item-width  {
        width: 48%;
    } 
.headbar{
    padding-left:5px; 
    line-height:45px;
    background:#fff;
    overflow: auto;
    width:800px;
    display:flex;
    border-left:2px solid #409eff;
}
.treeCss{
    padding-left:5px; 
    width:100%;
    background:#fff;
    margin:2px auto ;
    margin-top:5px;
   overflow:auto;
   height: calc(100vh - 130px);
}
.nodeLabel{
        font-size:12px;
        font-weight:500;
        padding-left:10px;
        color: black;
    }
.nodeRoot{
        width:20px;
        font-size:14px;
        font-weight:600;
    }  
.top{
        padding: 10px;
        background: rgba(0, 153, 229, .7);
        color: #fff;
        text-align: center;
        border-radius: 2px;
    }        
</style>
<style lang="less">
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:11px;
        }   
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{  //用于表格中checkbox disabled时为蓝色
        border-color :#3d77eb;
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-tree-node.is-current > .el-tree-node__content {
      background-color: #f3b6b6 !important;
      color:rgb(30, 44, 90);
    }
    .el-tree-node__content:hover {    
      background-color: #66b1ff87;
    }
    .tree-scroll{
        width :180px;
        border: 1px solid #f5dbdb;
        height: 100%;
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
